import { Box, useTheme } from '@mui/material'
import { ReactComponent as ArrowIcon } from './arrow.svg'
import { ReactComponent as VerticalArrowIcon } from './vertical-arrow.svg'
import { useTranslation } from 'react-i18next'
import { ICartItemRisk } from '../types'

const smallScreenWidth = 959

const RiskReason = ({ risk }: { risk: ICartItemRisk }) => {
    const { t } = useTranslation()
    const theme = useTheme()
    return (
        <Box
            sx={{
                position: 'relative',
                paddingTop: '4px',
                display: 'flex',
                alignItems: 'flex-start',

                [`@media (max-width:${smallScreenWidth}px)`]: {
                    paddingLeft: '16px',
                    flexDirection: 'column',
                    marginTop: '8px',
                },
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    left: 0,
                    top: 15,

                    [`@media (min-width:${smallScreenWidth}px)`]: {
                        display: 'none',
                    },
                }}
            >
                <VerticalArrowIcon />
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    [`@media (max-width:${smallScreenWidth}px)`]: {
                        marginBottom: '8px',
                    },
                }}
            >
                <Box
                    sx={{
                        minWidth: '90px',
                        color: '#5d6870',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        textAlign: 'right',
                        paddingTop: '4px',

                        [`@media (max-width:${smallScreenWidth}px)`]: {
                            textAlign: 'left',
                            minWidth: '50px',
                        },
                    }}
                >
                    {t('Common_Source')}
                </Box>
                <Box
                    sx={{
                        minWidth: '140px',
                        paddingLeft: '16px',
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: theme?.palette?.background?.paper,
                            fontSize: '12px',
                            fontWeight: 'bold',
                            padding: '2px 8px',
                            textTransform: 'uppercase',
                            color: '#3b454d',
                            border: '1px solid #aab0b4',
                            borderRadius: '5px',
                            width: 'fit-content',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {t(`Common_${risk.riskReason}`)}
                    </Box>
                </Box>
            </Box>

            <Box
                sx={{
                    display: 'flex',
                }}
            >
                <Box
                    sx={{
                        padding: '0px 8px',
                        [`@media (max-width:${smallScreenWidth}px)`]: {
                            display: 'none',
                        },
                    }}
                >
                    <ArrowIcon />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                    }}
                >
                    <Box
                        component={'span'}
                        marginLeft={'8px'}
                        fontSize={'14px'}
                        sx={{
                            wordBreak: 'break-word',
                            wordWrap: 'break-word',
                            overflow: 'auto',
                        }}
                    >
                        {risk.riskReason_ResourceFriendlyName}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default RiskReason
